import { render, staticRenderFns } from "./DetailNotificationBlogs.vue?vue&type=template&id=7dfbe7b9&"
import script from "./DetailNotificationBlogs.vue?vue&type=script&lang=js&"
export * from "./DetailNotificationBlogs.vue?vue&type=script&lang=js&"
import style0 from "./DetailNotificationBlogs.vue?vue&type=style&index=0&id=7dfbe7b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports